// tslint:disable:max-line-length
export const MailType = {
    connection: {
        name: 'First contact',
        description:
            'When your visitor logs into the Photo Website, an email is automatically send to them. Create and edit this email here.',
        canBeDisabled: true,
        editModes: ['html', 'easy'],
    },
    'webshop-active': {
        name: 'Webshop active',
        description:
            'When you do not activate the E-commerce feature immediately for your visitors, this email will be send to them whenever they can buy photos via the Photo Website. Create and edit this email here.',
        canBeDisabled: true,
        editModes: ['html', 'easy'],
    },
    'webshop-photo-access-active': {
        name: 'Webshop photo access active',
        description:
            'When you do not activate photos access in Photo Website immediately for your visitors, this email will be send to them whenever they can view photos via the Photo Website. Create and edit this email here.',
        canBeDisabled: true,
        editModes: ['html', 'easy'],
    },
    'qr-website': {
        name: 'Login PhotoPass',
        description:
            'When your visitor logs into the QR website, this email will be send to them including the link to start using their digital PhotoPass. Create and edit this email here. ',
        canBeDisabled: true,
        editModes: ['html', 'easy'],
    },
    order: {
        name: 'Digital photo order',
        description:
            'When your visitor purchases digital products on your Photo Website, they will receive an email with their product and the receipt. Create and edit this email here.',
        canBeDisabled: false,
        editModes: ['html'],
    },
    'video-available': {
        name: 'Video available',
        description:
            'When your visitor’s video uploaded, they will receive an email telling them it’s available on the Photo Website. Create and edit this email here.',
        canBeDisabled: false,
        editModes: ['html', 'easy'],
    },
    coupon: {
        name: 'Coupon card order',
        description:
            'When your visitor purchases a digital product with a coupon code, they will receive and email with their product and the receipt. Create and edit this email here.',
        canBeDisabled: false,
        editModes: ['html'],
    },
    receipt: {
        name: 'Receipt',
        description:
            'You can send a receipt for printed orders from the Print Station to your visitor. Create and edit this email here.',
        canBeDisabled: false,
        editModes: ['html'],
    },
    'share-photo': {
        name: 'Photo share',
        description:
            'Visitors have the option to share their photos from the Photo Website via email with family and friends. Create and edit this email here.',
        canBeDisabled: true,
        editModes: ['html', 'easy'],
    },
    'photoset-access': {
        name: 'Photoset download',
        description: 'Visitors can send photos to themselves from the Print Station. Create and edit this email here.',
        canBeDisabled: true,
        editModes: ['html', 'easy'],
    },
    'system-notification': {
        name: 'System notification',
        description: 'Lorem ipsum desc',
        forAdmin: true,
        canBeDisabled: true,
    },
    'notification-photo-limit-80': {
        name: 'Notification: 80% upload usage',
        description: 'Lorem ipsum desc',
        forAdmin: true,
        canBeDisabled: true,
    },
    'notification-print-limit-80': {
        name: 'Notification: 80% print usage',
        description: 'Lorem ipsum desc',
        forAdmin: true,
        canBeDisabled: true,
    },
    'notification-photo-limit-100': {
        name: 'Notification: 100% upload usage',
        description: 'Lorem ipsum desc',
        forAdmin: true,
        canBeDisabled: true,
    },
    'notification-print-limit-100': {
        name: 'Notification: 100% print usage',
        description: 'Lorem ipsum desc',
        forAdmin: true,
        canBeDisabled: true,
    },
    signup: {
        name: 'Notification: Registration',
        description: 'Lorem ipsum desc',
        forAdmin: true,
        canBeDisabled: true,
    },
    'password-reset': {
        name: 'Notification: Password reset',
        description: 'Lorem ipsum desc',
        forAdmin: true,
        canBeDisabled: false,
    },
    'customer-invalid-credit-card': {
        name: 'Notification: Invalid credit card',
        description: 'Lorem ipsum desc',
        forAdmin: true,
        canBeDisabled: false,
    },
    'campaign-created': {
        name: 'Notification: Campaign created',
        description: 'Lorem ipsum desc',
        forAdmin: true,
        canBeDisabled: false,
    },
    'user-device-authorization': {
        name: 'Notification: Login from new device',
        description: 'Lorem ipsum desc',
        forAdmin: true,
        canBeDisabled: false,
    },
    'report-subscriber-verification': {
        name: 'Data export: Email confirmation',
        description: 'Report subscriber email confirmation',
        forAdmin: true,
        canBeDisabled: false,
    },
    'financial-report-daily': {
        name: 'Data export: Daily report',
        description: 'Daily report email',
        forAdmin: true,
        canBeDisabled: false,
    },
    'financial-report-weekly': {
        name: 'Data export: Weekly report',
        description: 'Weekly report email',
        forAdmin: true,
        canBeDisabled: false,
    },
    'financial-report-monthly': {
        name: 'Data export: Monthly report',
        description: 'Monthly report email',
        forAdmin: true,
        canBeDisabled: false,
    },
    'parent-consent': {
        name: 'Parent Consent',
        description: 'Email sent to parents requesting consent for processing children photos',
        forAdmin: true,
        canBeDisabled: false,
    },
};
